// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1f8RG","label":"CategoryService_label__SnuwP","location":"CategoryService_location__HLaDM"};